<!-- {{ souscription.adresseSouscripteur }} // {{ souscription.adresseComplementSouscripteur }} --
{{ souscription.ville }} -- {{ souscription.paysNaissanceSouscripteur }}--{{ souscription.lieuNaissanceSouscripteur }} -->
<form
  #formulaire="ngForm"
  [ngClass]="{ body: true, 'cursor-wait': loading }"
  id="contenu"
>
  <div class="withArrow">
    <div class="retourArrow" (click)="retour()">
      <img src="../../../../../assets/img/arrow.svg" alt="" />
    </div>
    <div>
      <h3 class="titrePanel">Vous avez choisi la formule :</h3>
    </div>
  </div>

  <div id="formule" *ngIf="!!tarif">
    <div>
      <!-- <img class="scaleImg" src="../../../../../../assets/img/100FamilleSante.svg" alt="" /> -->
      <div class="recapOffre">
        <div class="recapImage">
          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
              tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE'
            "
            src="assets/img/100FamilleSante.svg"
            style="width: 90%"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE_ECO'"
            src="assets/img/Essentiel_Plus_Sante.svg"
            style="width: 90%"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE'"
            src="assets/img/Essentiel_Plus_Sante_Eco.svg"
            style="width: 90%"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
              tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE'
            "
            src="assets/img/100FamilleSante.svg"
            style="width: 90%"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'RELAXEO2'"
            src="assets/img/Relaxeo.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'CEGEMAV'"
            src="assets/img/vitaneor.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'CEGE_EQUILIBRE'"
            src="assets/img/cegema-equilibre.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
              tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE'
            "
            src="assets/img/cegema-flexibilite.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'KEREIS_SERENITE'"
            src="assets/img/cegema-serenite-sante.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'VITAMIN3'"
            src="assets/img/apivia.png"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'PARTICULIER'"
            src="assets/img/SLPart.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'SWLF_RETRAITES'"
            src="assets/img/SLSenior.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ZEN_SANTE_FAMILLE'"
            src="assets/img/Zenioo_Sante_Famille.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ZEN_SANTE_55_PLUS'"
            src="assets/img/Zenioo_Sante_55Plus.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ZEN_SANTE_SENIOR'"
            src="assets/img/Zenioo_Sante_Senior.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO'"
            src="assets/img/Zenioo_Sante_Senior_Eco.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
              tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO'
            "
            src="assets/img/aesio_imm_senior_eco.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR' ||
              tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR'
            "
            src="assets/img/mtx_vita_sante_famille.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR' ||
              tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR'
            "
            src="assets/img/mtx_vita_sante_plus55.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
              tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR'
            "
            src="assets/img/aesio_imm_senior.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ESS_SANTE_SENIOR'"
            src="assets/img/Essentiel_Sante_Senior.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'ESS_SANTE_FAMILLE'"
            src="assets/img/Essentiel_Sante_Famille.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'PROGR_SANTE_SENIOR'"
            src="assets/img/prog_sante_senior.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'PROGR_SANTE_FAMILLE'"
            src="assets/img/prog_sante_famille.svg"
            alt=""
          />

          <img
            class="scaleImg"
            *ngIf="tarif.produitTarif == 'CEGEMAEss'"
            src="assets/img/essentiel2.svg"
            alt=""
          />
          <img
            class="scaleImg"
            *ngIf="
              tarif.produitTarif == 'AC_PRIVILEGE' ||
              tarif.produitTarif == 'MTX_OPTIMUM_SANTE'
            "
            src="assets/img/OptimumSante.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div id="prixFormule">
      <div class="recapPrix">
        <p class="tFormule">
          {{ replaceFormule(tarif.codeFormule, tarif.produitTarif) }}
        </p>
        <div class="mensuel">
          <p>
            <span class="prix">{{
              (ate(tarif.montant) | number: '1.1-2')?.split('.')?.[0] || '0'
            }}</span>
            <span class="prixCentimes"
              >,{{
                (ate(tarif.montant) | number: '1.1-2')?.split('.')?.[1] || '00'
              }}</span
            >
            <span class="prix">€</span>/mois
          </p>
          <!-- <span class="prix">{{ (ate(tarif.Montant) | number: '1.1-2')?.split('.')?.[0] ?? '0' }}</span>
          ,{{ (ate(tarif.Montant) | number: '1.1-2')?.split('.')?.[1] ?? '00' }}€/mois -->
        </div>
        <div class="annuel">
          Soit {{ ate(tarif.montant) * 12 | number: '1.1-2' : 'fr' }}€/an tout
          inclus
        </div>
      </div>
    </div>
    <div id="btnFormule">
      <p>
        <button type="button" (click)="getDoc(tarif.produitTarif, docName.TG)">
          Voir les garanties
        </button>
      </p>
      <p>
        <button type="button" (click)="getDoc(tarif.produitTarif, docName.CG)">
          Voir la notice d’information
        </button>
      </p>
    </div>
  </div>
  <!-- excerce activité:{{exerceActivite}} -->
  <div id="exerceActivite">
    <p>
      <input
        [(ngModel)]="loiMadelin"
        type="checkbox"
        id="agree_exerce"
        name="agree"
        [checked]="loiMadelin == true"
      />
      <label for="agree_exerce"
        >J’exerce une activité non salariée non agricole et je souhaite
        bénéficier de la défiscalisation
        <a
          href="#"
          *ngIf="!isMobile"
          (click)="$event.preventDefault()"
          (mouseenter)="showJustificatif($event)"
          (mouseleave)="hideJustificatif($event)"
        >
          <b> Madelin. </b>
        </a>
        <a href="#" *ngIf="isMobile" (click)="showJustificatifMobile($event)">
          <b> Madelin. </b>
        </a>
      </label>
    </p>
  </div>

  <p
    class="div-orange hide"
    #justitifatif
    [ngStyle]="{ background: origine ? bg_justification : '#C0543A34' }"
  >
    Vous devrez nous faire parvenir les justificatifs de règlements des
    cotisations relatifs aux régimes obligatoires maladie et retraite, attestant
    que vous êtes à jour de vos cotisations et éventuellement de ceux de votre
    conjoint(e) et de vos enfants.
  </p>

  <div>
    <div>
      <h3 class="sousTitre2">
        Avez-vous déjà un contrat santé chez un autre assureur ?
      </h3>
      <div class="choixRadio cR_theme" [ngClass]="choixRadio_theme">
        <span>
          <input
            id="oui1_sante"
            [(ngModel)]="aDejaContrat"
            type="radio"
            name="contrat"
            [checked]="aDejaContrat == '1'"
            value="1"
          />
          <label for="oui1_sante" class="mag05"> OUI </label>
        </span>
        <span>
          <input
            id="non1_sante"
            [(ngModel)]="aDejaContrat"
            type="radio"
            name="contrat"
            [checked]="aDejaContrat == '0'"
            value="0"
          />
          <label for="non1_sante" class="mag05"> NON </label>
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="aDejaContrat == '1'">
    <div>
      <h3 class="sousTitre2">Depuis plus d’un an ?</h3>

      <div id="plusUnAn">
        <div class="choixRadio cR_theme" [ngClass]="choixRadio_theme">
          <span>
            <input
              [(ngModel)]="depuisPlusUnAn"
              type="radio"
              name="plusUnAn"
              [checked]="depuisPlusUnAn == '1'"
              value="1"
              id="oui2_sante"
            />
            <label for="oui2_sante" class="mag05"> OUI </label>
          </span>
          <span>
            <input
              [(ngModel)]="depuisPlusUnAn"
              type="radio"
              name="plusUnAn"
              [checked]="depuisPlusUnAn == '0'"
              value="0"
              id="non2_sante"
            />
            <label for="non2_sante" class="mag05"> NON </label>
          </span>
        </div>

        <div
          id="ps"
          [ngStyle]="{ background: origine ? bg_justification : '#ff950034' }"
        >
          <p *ngIf="depuisPlusUnAn == '0'">
            Votre contrat peut être résilié à sa date d’échéance, veillez à bien
            respecter le délai de 2 mois pour l’envoi de votre courrier
          </p>
          <p *ngIf="depuisPlusUnAn == '1'">
            Lorsque vous êtes assuré depuis plus d’un an, vous pouvez résilier
            votre assurance à tout moment en respectant un délai d’un mois. Vous
            pouvez donc être assuré chez nous à compter du
            {{ this.date35 | date: 'dd/MM/yyyy' }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h3 class="sousTitre2">Date d’effet du contrat</h3>
    <div class="ligneForm">
      <div class="FormGauche">
        <!-- <div class="groupInput"> -->
        <p>
          <label for="">Date de début du contrat souhaitée</label>
        </p>
        <p>
          <input
            type="text"
            name="dateDebutContrat"
            id="infoModalDebutContrat"
            [disabled]="true"
            [required]="true"
            class="input_style"
            [(ngModel)]="formatDateDebutContrat"
            min="{{ healthEffectDateMin | date: 'yyyy-MM-dd' }}"
            max="{{ dateEffetMax | date: 'yyyy-MM-dd' }}"
            [ngModelOptions]="{ standalone: true }"
          />
        </p>
        <p
          *ngIf="
            personne != null &&
            personne.dateDebutContrat &&
            formatDateEffetMin != null &&
            personne.dateDebutContrat < formatDateEffetMin
          "
          class="error-msg erreurAffiche"
        >
          La date d'effet doit être égale ou postérieure à
          {{ healthEffectDateMin | date }}
        </p>
        <p
          *ngIf="
            !!personne &&
            personne.dateDebutContrat &&
            formatDateEffetMax != null &&
            personne.dateDebutContrat > formatDateEffetMax
          "
          class="error-msg erreurAffiche"
        >
          La date d'effet ne peut pas être supérieur à 1 an.
        </p>
        <!-- </div> -->
      </div>
    </div>
  </div>

  <div>
    <h3 class="sousTitre2">Compte à débiter</h3>
    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label
            [ngClass]="{
              redLabel:
                inputEtablissement.invalid && inputEtablissement.touched,
            }"
          >
            Nom de l’établissement bancaire
            <span class="obligatoire sousTitre2"> *</span></label
          >
        </p>
        <p>
          <input
            class="input_style"
            #inputEtablissement="ngModel"
            name="nomEtablissement"
            [(ngModel)]="nomEtablissement"
            [required]="true"
            type="text"
          />
        </p>
        <p
          *ngIf="inputEtablissement.invalid && inputEtablissement.touched"
          class="error-msg erreurAffiche"
        >
          Nom de l’établissement bancaire requise
        </p>
      </div>
      <div class="FormDroite">
        <p>
          <label
            [ngClass]="{ redLabel: inputIban.invalid && inputIban.touched }"
          >
            IBAN <span class="obligatoire sousTitre2"> *</span></label
          >
        </p>
        <p>
          <input
            #inputIban="ngModel"
            class="input_style"
            name="iban"
            [(ngModel)]="iban"
            type="text"
            (change)="onInputChange()"
            [required]="true"
          />
        </p>
        <p
          *ngIf="inputIban.invalid && inputIban.touched"
          class="error-msg erreurAffiche"
        >
          Veuiller renseigner un IBAN valide
        </p>
        <p *ngIf="msgError" class="error-msg erreurAffiche">
          {{ msgError }}
        </p>
      </div>
    </div>
    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label [ngClass]="{ redLabel: inputBic.invalid && inputBic.touched }">
            BIC
            <span class="obligatoire sousTitre2"> *</span></label
          >
        </p>
        <p>
          <input
            #inputBic="ngModel"
            class="input_style"
            type="text"
            name="bic"
            [(ngModel)]="bic"
            [required]="true"
          />
        </p>
        <p
          *ngIf="inputBic.invalid && inputBic.touched"
          class="error-msg erreurAffiche"
        >
          Veuiller renseigner un BIC valide
        </p>
      </div>
    </div>
  </div>

  <!-- <div>
    <h3 class="sousTitre2">Rythme de votre règlement</h3>
    <div id="rythme">
      <label class="rythmelabel">
        <input
          type="radio"
          name="rythme"
          [(ngModel)]="fractionnement"
          value="mensuel"
          [checked]="fractionnement == 'mensuel'"
        />
        <span>Mensuel</span>
      </label>

      <label class="rythmelabel">
        <input
          type="radio"
          name="rythme"
          [(ngModel)]="fractionnement"
          value="annuel"
          [checked]="fractionnement == 'annuel'"
        />
        <span>Annuel</span>
      </label>
    </div>
  </div> -->

  <div>
    <h3 class="sousTitre2">Rythme de votre règlement</h3>
    <ul class="donate-now d_theme" [ngClass]="donate_theme">
      <li>
        <input
          type="radio"
          name="rythme"
          [(ngModel)]="fractionnement"
          value="mensuel"
          id="rythme_mensuel"
          [checked]="fractionnement == 'mensuel'"
        />
        <label
          for="rythme_mensuel"
          [ngStyle]="{
            border: origine ? btn_border_simple : '2px solid #FF9600',
          }"
          >Mensuel</label
        >
      </li>
      <li>
        <input
          type="radio"
          name="rythme"
          [(ngModel)]="fractionnement"
          value="annuel"
          id="rythme_annuel"
          [checked]="fractionnement == 'annuel'"
        />
        <label
          for="rythme_annuel"
          [ngStyle]="{
            border: origine ? btn_border_simple : '2px solid #FF9600',
          }"
          >Annuel</label
        >
      </li>
    </ul>
  </div>

  <div class="cR_theme marge_top" [ngClass]="choixRadio_theme">
    <h3 class="sousTitre2">
      Date du prélèvement <span class="obligatoire">*</span>
    </h3>
    <div
      id="datePrelevement"
      *ngIf="
        !!tarif &&
        (tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO' ||
          tarif.produitTarif == 'ZEN_SANTE_SENIOR' ||
          tarif.produitTarif == 'ZEN_SANTE_55_PLUS' ||
          tarif.produitTarif == 'ZEN_SANTE_FAMILLE')
      "
    >
      <div id="radio">
        <label for="date15" class="datePrelevementlabel">
          <input
            [checked]="datePrelevement == '5'"
            value="5"
            [(ngModel)]="datePrelevement"
            type="radio"
            name="date15"
            id="date15"
          />
          <span>le 5</span>
        </label>
        <label for="date12" class="datePrelevementlabel">
          <input
            [checked]="datePrelevement == '12'"
            value="12"
            [(ngModel)]="datePrelevement"
            type="radio"
            name="date12"
            id="date12"
          />
          <span>le 12</span>
        </label>
      </div>
    </div>
    <div
      id="datePrelevement"
      *ngIf="
        !!tarif &&
        tarif.produitTarif != 'ZEN_SANTE_SENIOR_ECO' &&
        tarif.produitTarif != 'ZEN_SANTE_SENIOR' &&
        tarif.produitTarif != 'ZEN_SANTE_55_PLUS' &&
        tarif.produitTarif != 'ZEN_SANTE_FAMILLE'
      "
    >
      <div id="radio">
        <label for="date10" class="datePrelevementlabel">
          <input
            [checked]="datePrelevement == '10'"
            value="10"
            [(ngModel)]="datePrelevement"
            type="radio"
            name="date10"
            id="date10"
          />
          <span>le 10</span>
        </label>
        <label for="date15" class="datePrelevementlabel">
          <input
            [checked]="datePrelevement == '15'"
            value="15"
            [(ngModel)]="datePrelevement"
            type="radio"
            name="date15"
            id="date15"
          />
          <span>le 15</span>
        </label>
      </div>
    </div>
    <p class="prelevementauto">
      <label class="mag05">
        <input type="radio" name="ModePaiement" checked value="Prelevement" />
        <span> Prélèvement automatique<span class="obligatoire">*</span> </span>
      </label>
    </p>
    <div class="MentionObligatoire">
      <p class="mentionObg">
        * J'accepte, en cas de rejet de prélèvement automatique, que les frais
        éventuels facturés par l'organisme financier restent à ma charge.
      </p>
    </div>
  </div>

  <div *ngIf="errorFraude">
    <p class="errorFraude" style="color: red; font-weight: bold">
      Nous ne sommes pas en mesure de continuer la souscription en ligne. Merci
      de contacter un conseiller au numéro indiqué dans la bandeau
    </p>
  </div>

  <div id="validation">
    <button
      type="button"
      class="marge_top validationBTN"
      (click)="validerContrat()"
      [ngClass]="{ gray: true, orange: !formulaire.invalid && isIBANValid() }"
      [disabled]="formulaire.invalid || loading || !isIBANValid()"
      [ngStyle]="{
        background: origine ? btn_bg : '#6D3311',
      }"
    >
      <div *ngIf="loading" class="spinner-border text-light" role="status">
        <span class="sr-only">Traitement...</span>
      </div>
      Valider et poursuivre
      <span> <img src="../../../../../../assets/img/row.svg" alt="" /></span>
    </button>
  </div>
</form>
